import { defineComponent as _defineComponent } from 'vue'
import TimeList from "@/components/list/TimeList.vue";
import ApprovalChip from "../table/ApprovalChip.vue";
import {
  ApprovalShift,
  ApprovalShiftUser
} from "@/models/approval/ApprovalResponse";
import { DateTime } from "luxon";
import { DataTableHeader } from "vuetify";
import { AttendanceFlowDat } from "@/models/transaction/AttendanceFlowDat";

type Props = {
  dat: AttendanceFlowDat;
  shift: ApprovalShift;
  reasons: string[];
  approvals: ApprovalShiftUser[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AttendanceExpandItem',
  props: {
    dat: null,
    shift: null,
    reasons: null,
    approvals: null
  },
  setup(__props: any) {

const beforeHeader = [
  { text: "開始時間： ", value: "preStartTime" },
  { text: "終了時間： ", value: "preEndTime" },
  { text: "総休憩時間： ", value: "preBreakTime" },
  { text: "深夜休憩時間： ", value: "preMidnightBreakTime" }
] as const;

const afterHeader = [
  { text: "開始時間： ", value: "afterStartTime" },
  { text: "終了時間： ", value: "afterEndTime" },
  { text: "総休憩時間： ", value: "afterBreakTime" },
  { text: "深夜休憩時間： ", value: "afterMidnightBreakTime" }
] as const;

const shiftHeader = [
  { text: "開始時間： ", value: "startTime" },
  { text: "終了時間： ", value: "endTime" },
  { text: "総休憩時間： ", value: "breakTime" },
  { text: "深夜休憩時間： ", value: "midnightBreakTime" }
] as const;

const approvalHeaders: DataTableHeader[] = [
  { text: "承認日", value: "approvalDate", divider: true },
  { text: "承認ユーザ", value: "approvalUserName", divider: true },
  {
    text: "承認状態",
    value: "approvalFlag",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  }
];

const formatDate = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE) HH:mm:ss");
};



return { __sfc: true,beforeHeader, afterHeader, shiftHeader, approvalHeaders, formatDate, TimeList, ApprovalChip }
}

})